<template>
    <v-container>
    <div>
        <v-row justify="center"  
        >
            <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    xl="12"
            > 
            <v-row justify="center">
                <div>        
                    <p class="contactUs-text">
                        Whether <strong>you</strong> have a question about our menu, catering, pricing or anything else, our team is ready to answer your question. 
                    </p>
                </div>
            </v-row>          
            </v-col>
            </v-row>
            <v-row justify="space-around">
                <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="4"
                    xl="3"
                >

                    <v-card
                        color="#FAFAFA"
                        elevation="3"
                        :width="card_width"
                        :height="card_height"
                        class="contact-cards"
                        shaped
                    >
                        <v-card-title>
                            <v-icon 
                                x-large
                                color="primary"
                            >mdi-phone</v-icon>
                            <p class="ml-10 card-text">
                                <strong>
                                    Call Us
                                </strong>
                            </p>
                        </v-card-title>
                        <span class="phone">
                            <a href="tel:206-242-2011" class="phone">206-242-2011</a>
                            
                        </span>
                    </v-card>
        
                </v-col>
                <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="4"
                    xl="3"
                >
        

                    <v-card
                        color="#FAFAFA"
                        elevation="3"
                        :width="card_width"
                        :height="card_height"
                        class="contact-cards"
                        shaped
                    >
                        <v-card-title>
                            <v-icon x-large
                                color="primary"
                            >mdi-google-maps</v-icon>
                            <p class="ml-10 card-text">
                                <strong>
                                    Visit Us
                                </strong>
                            </p>

                        </v-card-title>
                        <v-card-text>
                        <span>14223 Tukwila International Blvd, Tukwila, WA 98168</span>
                        </v-card-text>
                        <googleMaps name="juba"></googleMaps>
                    
                        <v-btn
                        text
                        color="primary"
                            @click="openNav('https://goo.gl/maps/WDsCG1z6nXpvX2Ge9')"
                        >
                            <v-spacer></v-spacer>
                            directions
                        </v-btn>

                    </v-card>
            
                </v-col>
                    <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="4"
                        xl="3"
                    >
                        
                            <v-card
                                color="#FAFAFA"
                                elevation="3"
                                :width="card_width"
                                :height="card_height"
                                class="contact-cards"
                                shaped
                            >
                            <v-card-title>
                                <v-icon x-large
                                    color="primary"
                                >mdi-email</v-icon>
                                <p class="ml-10 card-text">
                                    <strong>
                                        Message Us
                                    </strong>
                                </p>
                            </v-card-title>
                            <v-card-text class=" grow">
                            
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" class="card-text" 
                                    active-class="send-message-card"
                                    @click="sendEmail(email)"
                                
                                >
                                
                                    <strong>
                                        Send message
                                    </strong>
                                </v-btn>
                            </v-card-actions>
                            </v-card>

        
            </v-col>
        </v-row>
    </div>
</v-container>
</template>
<script>
    import googleMaps from '@/views/googleMaps'
    export default {
        name: 'contactUs',
        components: {
            googleMaps
        },
        data() {
            return {
                email: 'noor7me@gmail.com',
                card_width: 600,
                card_height:  400,

                
            }
        }, 
        methods: {
            openNav (url) {
                window.location.href=url
            }, 
            sendEmail(email) {
                window.location.href = `mailto:${email}`
            }
        }
    }
</script>
<style  scoped>

    .contactUs-text{
        
        font-style: normal;
        letter-spacing: 1.8px;
        font-size: 18px;
        margin-left: 16px;
        margin-right: 16px;
        
    }
    .card-text{
        
        transition: all 0.2s linear;
        font-style: normal;
        letter-spacing: 1.2px;
        line-height: 50px;
        font-size: 18px;
        color: rgb(2, 0, 7);
        
    }
    .contact-cards{
        
        transition: all 0.2s linear;
        cursor: pointer;
        border-radius: 25px;
        display: flex;
        flex-direction: column;

    }
    .contact-cards:hover{
        transform: scale(1.08);
        box-shadow: 0 3px 12px 0 rgba(99, 2, 2, 0.4), 0 1px 15px 0 rgba(114, 3, 3, 0.19);
    }
    .send-message-card {
        border-radius: 50px;
        color: blue;
    }

   .phone {
     
        font-size: 160%;
        font-style: normal;
        font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif; 
        line-height: 20px;
        margin-top: 100px;
        padding: 10px 20px;
        text-align: center;
        text-decoration: none;
        cursor: pointer;
        
        color: #60050B
}
.google-directions{
    padding: 10px
}

</style>